import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Users, DollarSign, Clock } from 'lucide-react';
import { Card } from "@/components/ui/card";

const Slide13UnitEconomics = () => {
    return (
        <div className="w-full h-full bg-background p-8 lg:p-16 flex flex-col justify-center relative">
            {/* Background Grid Texture */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
                style={{ backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)', backgroundSize: '40px 40px' }}
            />
            <div className="max-w-6xl mx-auto w-full">
                <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    className="mb-12"
                >
                    <h2 className="text-4xl lg:text-6xl font-bold mb-4">Sustainable <span className="text-primary">Economics</span></h2>
                    <p className="text-xl text-muted-foreground">Base Case (Seed Stage)</p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

                    {/* CAC */}
                    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
                        <Card className="bg-card border-border hover:border-primary transition-colors h-48 flex flex-col justify-between p-6">
                            <div className="flex justify-between items-start">
                                <span className="text-muted-foreground font-medium">CAC</span>
                                <Users className="w-5 h-5 text-muted-foreground" />
                            </div>
                            <div>
                                <div className="text-4xl font-bold text-white mb-1">₹300-500</div>
                                <div className="text-sm text-primary">Efficient acquisition</div>
                            </div>
                        </Card>
                    </motion.div>

                    {/* ARPU */}
                    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
                        <Card className="bg-card border-border hover:border-primary transition-colors h-48 flex flex-col justify-between p-6">
                            <div className="flex justify-between items-start">
                                <span className="text-muted-foreground font-medium">ARPU (Pro)</span>
                                <DollarSign className="w-5 h-5 text-muted-foreground" />
                            </div>
                            <div>
                                <div className="text-4xl font-bold text-primary mb-1">₹999<span className="text-lg text-muted-foreground">/mo</span></div>
                                <div className="text-sm text-primary">High value capture</div>
                            </div>
                        </Card>
                    </motion.div>

                    {/* Payback */}
                    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}>
                        <Card className="bg-card border-border hover:border-primary transition-colors h-48 flex flex-col justify-between p-6">
                            <div className="flex justify-between items-start">
                                <span className="text-muted-foreground font-medium">Payback Period</span>
                                <Clock className="w-5 h-5 text-muted-foreground" />
                            </div>
                            <div>
                                <div className="text-4xl font-bold text-white mb-1">6-9 <span className="text-2xl text-muted-foreground">Months</span></div>
                                <div className="text-sm text-primary">Quick recovery</div>
                            </div>
                        </Card>
                    </motion.div>

                    {/* LTV */}
                    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }}>
                        <Card className="bg-card border-border hover:border-primary transition-colors h-48 flex flex-col justify-between p-6">
                            <div className="flex justify-between items-start">
                                <span className="text-muted-foreground font-medium">LTV (3-Year)</span>
                                <TrendingUp className="w-5 h-5 text-muted-foreground" />
                            </div>
                            <div>
                                <div className="text-4xl font-bold text-primary mb-1">&gt; ₹4,000</div>
                                <div className="text-sm text-primary">Strong retention</div>
                            </div>
                        </Card>
                    </motion.div>

                </div>

                <div className="mt-8 text-center text-muted-foreground text-sm">
                    *Contribution margins positive via hybrid inference optimization.
                </div>
            </div>
        </div>
    );
};

export default Slide13UnitEconomics;